import { AnyAction } from "redux";
import { NotificationState } from "../types/notificationTypes";
import {
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
} from "../actions/notificationActions";

const initialState: NotificationState = {
  notificationsData: { notifications: [], totalRecords: 0 },
  loading: false,
  error: null,
};

const notificationReducer = (
  state = initialState,
  action: AnyAction
): NotificationState => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notificationsData: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    // Handle other user-related actions here...
    default:
      return state;
  }
};

export default notificationReducer;
